import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-9366668c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { style: {"border":"1px solid #ccc"} }
const _hoisted_2 = { class: "w-e-text-container" }
const _hoisted_3 = ["innerHTML"]

import '@wangeditor/editor/dist/css/style.css' // 引入 css
import {Editor, Toolbar} from '@wangeditor/editor-for-vue'
import {onBeforeUnmount, onMounted, ref} from "vue";
import {shallowRef} from "vue";
import {DateFieldType} from "@/components/business/crud/interface/FieldType";
import {WidgetInfo} from "@/components/business/crud/widgets/WidgetContainer";
import {ScForm} from "@/models/ScForm";
import {tokenManager} from "@/util/token";
import config from "@/config";
import ScBtn from "@/components/common/widget/ScBtn.vue";
import {Translate} from "@/util/translate/ToolGood.Words.Translate";


import {definedWidgetMeta} from "@/components/business/crud/widgets/widgetManager";

export const meta = definedWidgetMeta({
  size: {edit: 'large', show: 'large'},
});

export default /*#__PURE__*/_defineComponent({
  __name: 'EditorForm',
  props: {
    propName: {},
    widget: {},
    info: {}
  },
  setup(__props: any) {

const props = __props;

const data = ScForm.useFormData();

const editorRef = shallowRef<any>()
const handleCreated = (editor: unknown) => {
  editorRef.value = editor // 记录 editor 实例，重要！
}
// 组件销毁时，也及时销毁编辑器
onBeforeUnmount(() => {
  const editor = editorRef.value
  if (editor == null) return
  editor.destroy()
})

// 内容 HTML
const valueHtml = ref(data.value[props.propName])
const toolbarConfig = {}
const editorConfig = {
  placeholder: '请输入' + props.info.title,
  MENU_CONF: {
    uploadImage: {
      server: config.uploadApiPath,
      fieldName: 'file',
      maxFileSize: 8 * 1024 * 1024,
      maxNumberOfFiles: 10,
      headers: {
        ...tokenManager.get(),
      },
      customInsert(res: any, insertFn: any) {
        if (res.data?.path) {
          insertFn(config.uploadPath + res.data.path, "", "")
        }
      }
    },
    uploadVideo: {
      server: config.uploadApiPath,
      fieldName: 'file',
      maxFileSize: 20 * 1024 * 1024,
      allowedFileTypes: ['video/*'],
      maxNumberOfFiles: 10,
      headers: {
        ...tokenManager.get(),
      },
      customInsert(res: any, insertFn: any) {
        if (res.data?.path) {
          insertFn(config.uploadPath + res.data.path, "")
        }
      }
    }
  }
}

const translate = new Translate();

function tran(type: 1 | 2) {
  if (!editorRef.value) {
    return;
  }
  const origin = editorRef.value.getHtml();
  if (type === 1) {
    editorRef.value.setHtml(translate.ToSimplifiedChinese(origin, 2))
  } else {
    editorRef.value.setHtml(translate.ToTraditionalChinese(origin, 2))
  }
}

function onChange(editor: any) {
  data.value[props.propName] = editor.getHtml();
}



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _withDirectives(_createElementVNode("div", null, [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_unref(Toolbar), {
          style: {"border-bottom":"1px solid #ccc"},
          editor: editorRef.value,
          defaultConfig: toolbarConfig,
          mode: "default"
        }, null, 8, ["editor"]),
        _createVNode(_unref(Editor), {
          style: {"height":"500px","overflow-y":"hidden"},
          modelValue: valueHtml.value,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((valueHtml).value = $event)),
          defaultConfig: editorConfig,
          mode: "default",
          onOnCreated: handleCreated,
          onOnChange: onChange
        }, null, 8, ["modelValue"])
      ])
    ], 512), [
      [_vShow, _ctx.info.status === 'edit']
    ]),
    _withDirectives(_createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", {
        innerHTML: _unref(data)[_ctx.propName],
        "data-slate-editor": ""
      }, null, 8, _hoisted_3)
    ], 512), [
      [_vShow, _ctx.info.status === 'show']
    ])
  ], 64))
}
}

})